import { useState } from "react";

export interface RefreshButtonProps {
  onRefresh: () => Promise<void>;
}

export function RefreshButton({ onRefresh }: RefreshButtonProps): JSX.Element {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      className="vmc-tbtn"
      data-tour="viewer.refresh"
      disabled={busy}
      onClick={async () => { setBusy(true); try { await onRefresh(); } finally { setBusy(false); } }}
    >
      ↻ {busy ? "Refreshing…" : "Refresh"}
    </button>
  );
}
